<h2 mat-dialog-title>Update PAN Number</h2>
<form [formGroup]="panForm" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <div class="p-field">
      <label for="pan">PAN Number</label>
      <input
        pInputText
        id="pan"
        type="text"
        formControlName="pan"
        class="w-full"
        maxlength="10"
        style="text-transform: uppercase"
      />
      <small
        class="p-error"
        *ngIf="
          panForm.controls['pan'].invalid &&
          (panForm.controls['pan'].dirty || panForm.controls['pan'].touched)
        "
      >
        Please enter a valid PAN number (Format: ABCDE1234F)
      </small>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-secondary"
      (click)="onCancel()"
    ></button>
    <button
      pButton
      type="submit"
      label="Update"
      [disabled]="panForm.invalid || isLoading"
    ></button>
  </div>
</form>
